export class GlobalOperations {

    static ProxyUrl: string = "https://cors-anywhere.herokuapp.com/";
    static BaseUrl: string = "https://crmapi.albinasoft.com";
    // static BaseUrl: string = this.ProxyUrl + this.ApiUrl;

}

